import { Link } from 'react-router';

import { getFontBase, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import { ThemedElement } from 'utils/types';

import Typography from '../Typography';

interface IProps {
  disabled?: boolean;
  variant: 'bold' | 'primary' | 'regular';
}

export const getBaseLinkStyle = (prefix = ['components', 'link', 'regular']) => {
  return css`
    text-decoration: underline;

    ${getFontBase([...prefix, 'unread', 'base'])};

    &:hover {
      ${getFontBase([...prefix, 'unread', 'hover'])};
    }

    &:active {
      ${getFontBase([...prefix, 'unread', 'pressed'])};
    }

    &:visited {
      ${getFontBase([...prefix, 'read', 'base'])};

      &:hover {
        ${getFontBase([...prefix, 'read', 'hover'])};
      }

      &:active {
        ${getFontBase([...prefix, 'read', 'pressed'])};
      }
    }
  `;
};

const linkStyles = css<ThemedElement<IProps>>`
  line-height: 143%;
  word-break: break-word;
  transition: all 0.3s ease;

  ${({ disabled }) =>
    disabled
      ? css`
          cursor: default;
        `
      : css`
          text-decoration: underline;
        `}

  ${({ themePrefix, variant }) => {
    const prefix = themePrefix || ['components', 'link', variant];

    return css<IProps>`
      ${({ disabled: isDisabled }) =>
        isDisabled
          ? css`
              ${getFontBase([...prefix, 'unread', 'disabled'])};

              &:visited {
                ${getFontBase([...prefix, 'read', 'disabled'])};
              }
            `
          : getBaseLinkStyle(prefix)}
    `;
  }};
`;

export const AppLink = styled(Link)<ThemedElement<IProps>>`
  ${linkStyles}
`;

export const GlobalLink = styled.a<ThemedElement<IProps>>`
  ${linkStyles}
`;

export const Text = styled(Typography)`
  word-break: break-word;
  color: ${getPrefixedVar(['components', 'detail', 'text'])};
`;
